// extracted by mini-css-extract-plugin
export default {"row":"manualAdjustmentReport_row__02LaU"};